export const ACCOUNTANT_EMAILS = ['12tax@oompay.com'];
